module.exports = __webpack_public_path__ + "img/fix.b58c365f.svg";